import * as React from 'react';
import { IconProps } from '../types';

const IcClose = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M20.682 3.817a1.157 1.157 0 0 1 0 1.637L5.954 20.182a1.157 1.157 0 0 1-1.637-1.636L19.046 3.817a1.157 1.157 0 0 1 1.636 0Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M4.318 3.817a1.157 1.157 0 0 1 1.636 0l14.729 14.729a1.157 1.157 0 0 1-1.637 1.636L4.318 5.454a1.157 1.157 0 0 1 0-1.637Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcClose;